import clsx from "clsx";
import ModuleContainer from "components/legacy/modules/ModuleContainer/ModuleContainer";
import _ from "lodash";

import { ContentModuleForDisplay } from "./types";

type ContentPreviewProps = {
  modules: ContentModuleForDisplay[] | null;
  contentInert?: boolean;
  className?: string;
};

function ContentPreview({
  modules,
  contentInert,
  className,
}: ContentPreviewProps) {
  return (
    <div className={className}>
      <div
        className={clsx({ "pointer-events-none": contentInert })}
        // @ts-expect-error - "inert" is new to the spec and the types do not exist yet
        inert={contentInert}
      >
        {_.map(modules, (module, index) => (
          <ModuleContainer
            key={`${module.id}-${index}`}
            guideId="fake-guide-id"
            stageId="fake-stage-id"
            isPreview
            {...module}
          />
        ))}
      </div>
    </div>
  );
}

export default ContentPreview;
